import dynamic from 'next/dynamic';
import { useScreenSizeContext } from '@/components/ScreenSize.context';
import { useAppSelector } from '@/redux';

const SubMenuMobile = dynamic(() => import('@/components/layout/SubMenuMobile'), { ssr: true });
SubMenuMobile.displayName = 'SubMenuMobile';
const SubMenuDesktop = dynamic(() => import('@/components/layout/SubMenuDesktop'), { ssr: true });
SubMenuDesktop.displayName = 'SubMenuDesktop';
const BlogMenuModal = dynamic(() => import('@/components/layout/modals/BlogMenuModal'), { ssr: true });
BlogMenuModal.displayName = 'BlogMenuModal';
const CellarMenuModal = dynamic(() => import('@/components/layout/modals/CellarMenuModal'), { ssr: false });
CellarMenuModal.displayName = 'CellarMenuModal';

type SubMenuProps = {
	type?: string;
	rest?: {
		links: { title: string; url: string }[];
		currentPage: string;
	};
};

export const SubMenu = ({ type = 'blog', rest }: SubMenuProps) => {
	const blogMenuModalVisible = useAppSelector(({ gui }) => gui.blogMenuModalVisible);
	const cellarMenuModalVisible = useAppSelector(({ gui }) => gui.cellarMenuModalVisible);
	const { isMobileOrTablet } = useScreenSizeContext();

	if (type === 'blog') {
		return (
			<>
				{isMobileOrTablet && <SubMenuMobile type={type} />}
				{blogMenuModalVisible && <BlogMenuModal />}
			</>
		);
	}

	if (type === 'cellar' && !isMobileOrTablet) {
		return <SubMenuDesktop {...rest} />;
	}

	return (
		<>
			<SubMenuMobile type={type} />
			{cellarMenuModalVisible && <CellarMenuModal links={rest?.links} />}
			{blogMenuModalVisible && <BlogMenuModal />}
		</>
	);
};

export default SubMenu;
